import { Avatar, Box, IconButton } from '@mui/material'
import { HeartIcon, SaveIcon } from '../../../../../core/global/Icons'
import { decodeTitleHTML } from "../../../../../core/global/DecodeHTML";
import { timeFormat } from "../../../../../core/global/Format";

export const Publication = ({ location, v, viewHandler, unsavePublicationHandler }) => {
    const timePosted = timeFormat(v.published_date)
    const title = decodeTitleHTML(v.title, 55)    

    return (
        <Box borderBottom="1px solid #F7F8F8" display="flex" justifyContent="space-between" gap="16px" p="16px">
            <Box onClick={() => viewHandler(v.id)} display="flex" alignItems="center" gap="16px">
                {
                    v.file_link === null ||  v.file_link.split('/')[3] === '' ?
                        <Box bgcolor="#F2F6F9" height="100px" width="160px" borderRadius="12px" />
                    :
                    <Box height="100px" width="160px">
                        <img src={v.file_link} alt="banner" style={{height: '100%', width: '100%', objectFit: 'cover', borderRadius: '12px'}} />
                    </Box>
                }
                <Box width="100%" display="flex" flexDirection="column" gap="16px" >
                    {
                        location.pathname.split('/')[3] === 'article' &&
                            <Box display="flex" alignItems="center" gap="8px">
                                <Avatar src={v.profile !== null ? JSON.parse(v.profile).profile : null} alt="logo" sx={{width: '20px', height: '20px'}} />
                                <Box fontSize="10px">{`${v.first_name} ${v.last_name}`}</Box>
                            </Box>
                    }
                    {
                        location.pathname.split('/')[3] === 'news' && <Box fontSize="12px" color="#E34935">{v.source_name}</Box>
                    }
                    {
                        location.pathname.split('/')[3] === 'updates' && <Box fontSize="12px" color="#453FBA">{v.category_name}</Box>
                    }
                    <Box fontSize="14px" fontWeight="600">{title}</Box>
                    <Box display="flex" alignItems="center" gap="16px">
                        <Box fontSize="10px" color="#5B6167">{timePosted}</Box>
                        <Box display={v.reaction_count === 0 ? "none" : "flex"} alignItems="center" gap="8px">
                            <HeartIcon height="12px" width="11px" type="active"/>
                            <Box fontSize="10px">{v.reaction_count}</Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box>
                <IconButton onClick={() => unsavePublicationHandler(v.save_id, v.id)}>
                    <SaveIcon height="25px" width="24px" type="active"/>
                </IconButton>
            </Box>
        </Box>
    )
}

export const Bulletin = ({ v, viewHandler }) => {
        
    const timePosted = timeFormat(v.published_date)
    const title = decodeTitleHTML(v.title, 60)

    return (
         <Box width="100%" display="flex" alignItems="center" p="16px" gap="16px" borderBottom="1px solid #F7F8F8">
            <Box onClick={() => viewHandler(v.id)} width="100%" display="flex" flexDirection="column" gap="16px" >
                <Box fontSize="14px" fontWeight="600">{title}</Box>
                <Box fontSize="10px" color="#5B6167">{timePosted}</Box>
            </Box>
            <IconButton>
                <SaveIcon height="25px" width="24px" type="active"/>
            </IconButton>
        </Box>
    )
}
